export const isTierSoldOut = (tier) => {
  const quantityAvailable = Number(tier?.quantity_available || 0);
  const quantitySold = Number(tier?.quantity_sold || 0);
  return quantitySold >= quantityAvailable && quantityAvailable > 0;
};

export const isEventSoldOut = (tiers = []) => {
  const list = Array.isArray(tiers) ? tiers : [];
  if (!list.length) return false;
  return list.every((tier) => isTierSoldOut(tier));
};

export const soldOutMapFromTiers = (tiers = []) => {
  const grouped = new Map();
  (Array.isArray(tiers) ? tiers : []).forEach((tier) => {
    const eventId = String(tier?.event_id || "");
    if (!eventId) return;
    if (!grouped.has(eventId)) grouped.set(eventId, []);
    grouped.get(eventId).push(tier);
  });

  const soldOutByEventId = {};
  grouped.forEach((eventTiers, eventId) => {
    soldOutByEventId[eventId] = isEventSoldOut(eventTiers);
  });
  return soldOutByEventId;
};
